import { render, staticRenderFns } from "./RelationIntentList.vue?vue&type=template&id=8e4293f4"
import script from "./RelationIntentList.vue?vue&type=script&lang=js"
export * from "./RelationIntentList.vue?vue&type=script&lang=js"
import style0 from "./RelationIntentList.vue?vue&type=style&index=0&id=8e4293f4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports